"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardWebsiteRequestBodySchema = void 0;
const v4_1 = require("zod/v4");
const zod_1 = require("../zod");
exports.OnboardWebsiteRequestBodySchema = v4_1.z.object({
    url: zod_1.ZodHttpURL,
});
